import { executeQuery } from "utils/services/apiServices";
import { FETCH_INAPP_PURCHASE_PAYMENT_RESPONSE, FETCH_RMA_PAYMENT_RESPONSE, FETCH_STRIPE_PAYMENT_RESPONSE } from "../graphql/query";
import { actionTypes, InAppPaymentProps, RmaPaymentProps, StripePaymentProps } from "./actionType";


// fetch rma 
export const fetchRmaPaymentResponseRequest = () => ({
  type: actionTypes.FETCH_RMA_PAYMENT_REQUEST,
});

export const fetchRmaPaymentResponseSuccess = (payload: RmaPaymentProps[]) => ({
  type: actionTypes.FETCH_RMA_PAYMENT_SUCCESS,
  payload,
});

export const fetchRmaPaymentResponseFail = (payload: string) => ({
  type: actionTypes.FETCH_RMA_PAYMENT_FAIL,
  payload,
});

export const fetchRmaPaymentResponse = (limit:number, offset:number) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchRmaPaymentResponseRequest());
      const response = await executeQuery(FETCH_RMA_PAYMENT_RESPONSE, {limit, offset});
      const jsonData = response.data?.GetRmaPaymentResponse;
      if (jsonData?.error === null) {
        dispatch(fetchRmaPaymentResponseSuccess(jsonData?.data.Message));
      } else {
        dispatch(fetchRmaPaymentResponseFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchRmaPaymentResponseFail("Failed to fetch rma payment response"));
    }
  };
};
// fetch stripe 
export const fetchStripePaymentResponseRequest = () => ({
  type: actionTypes.FETCH_STRIPE_PAYMENT_REQUEST,
});

export const fetchStripePaymentResponseSuccess = (payload: StripePaymentProps[]) => ({
  type: actionTypes.FETCH_STRIPE_PAYMENT_SUCCESS,
  payload,
});

export const fetchStripePaymentResponseFail = (payload: string) => ({
  type: actionTypes.FETCH_STRIPE_PAYMENT_FAIL,
  payload,
});

export const fetchStripePaymentResponse = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchStripePaymentResponseRequest());
      const response = await executeQuery(FETCH_STRIPE_PAYMENT_RESPONSE);
      const jsonData = response.data?.GetStripePaymentResponse;
      if (jsonData?.error === null) {
        dispatch(fetchStripePaymentResponseSuccess(jsonData?.data.Message));
      } else {
        dispatch(fetchStripePaymentResponseFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchStripePaymentResponseFail("Failed to fetch stripe payment response"));
    }
  };
};

// fetch stripe 
export const fetchInAppPurchaseResponseRequest = () => ({
  type: actionTypes.FETCH_INAPP_PURCHASE_REQUEST,
});

export const fetchInAppPurchaseResponseSuccess = (payload: InAppPaymentProps[]) => ({
  type: actionTypes.FETCH_INAPP_PURCHASE_SUCCESS,
  payload,
});

export const fetchInAppPurchaseResponseFail = (payload: string) => ({
  type: actionTypes.FETCH_INAPP_PURCHASE_FAIL,
  payload,
});

export const fetchInAppPurchaseResponse = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchInAppPurchaseResponseRequest());
      const response = await executeQuery(FETCH_INAPP_PURCHASE_PAYMENT_RESPONSE);
      const jsonData = response.data?.GetInatePaymentResponse;
      if (jsonData?.error === null) {
        dispatch(fetchInAppPurchaseResponseSuccess(jsonData?.data.Message));
      } else {
        dispatch(fetchInAppPurchaseResponseFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchInAppPurchaseResponseFail("Failed to fetch stripe payment response"));
    }
  };
};

